import { Button } from '@mantine/core';
import { FC, RefObject } from 'react';

import CalendarNavigation from '@/components/CalendarView/CalendarNavigation.tsx';
import CalendarSidebar from '@/components/CalendarView/CalendarSidebar.tsx';
import CalendarView from '@/components/CalendarView/CalendarView.tsx';
import { Page } from '@/components/Page.tsx';
import PageTitleBar from '@/components/PageTitleBar.tsx';

import useBreakpoints from '@/hooks/useBreakpoints.ts';
import { useCalendarScroll } from '@/hooks/useCalendarScroll.ts';

import { useCalendarStore } from '@/stores/calendarStore.ts';

import { openAppointmentScheduler } from '@/utils/modal/appointmentSchedulerUtils.tsx';
import { openWalkInModal } from '@/utils/modalUtils.tsx';
import { cn } from '@/utils/styleUtils.ts';

const CalendarViewPage: FC = () => {
    const { calendar_scroll_ref, scrollHorizontally, scrollVertically } = useCalendarScroll();
    const { is_xl } = useBreakpoints();
    const is_sidebar_open = useCalendarStore((state) => state.is_sidebar_open);

    return (
        <Page className="gap-10 p-4 pb-0 xl:p-10 xl:pb-0 xl:pt-5">
            <PageTitleBar
                title={is_xl ? 'Kalender' : undefined}
                middleComponent={
                    <CalendarNavigation scrollHorizontally={scrollHorizontally} scrollVertically={scrollVertically} />
                }
                ctaButton={
                    <Button
                        variant="filled"
                        onClick={() => openWalkInModal(() => openAppointmentScheduler({ mode: 'book' }))}
                    >
                        Termin erstellen
                    </Button>
                }
            />
            <div className={cn('flex h-full w-full', is_sidebar_open && 'gap-6')}>
                <CalendarSidebar />
                <CalendarView horizontalScrollRef={calendar_scroll_ref as RefObject<HTMLDivElement>} />
            </div>
        </Page>
    );
};

export default CalendarViewPage;
